import { ArchiveBoxIcon } from "@heroicons/react/24/outline"
import { Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import Capsules from "./Capsules"
import RouteKeys from "constants/route-keys"

const _routes: RouteElement[] = [
    {
        // use empty string so the list renders at /search-capsules
        route: '',
        title: 'Search Capsules',
        key: RouteKeys.SEARCH_CAPSULES,
        component: Capsules,
        icon: ArchiveBoxIcon,
        display: true
    }
]
const SearchCapsules = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default SearchCapsules